import type { VehicleFacetOption } from './vehicleFacetOptions';

type VehicleFilterChipsProps<T extends string> = {
    legend: string;
    options: VehicleFacetOption<T>[];
    selected: T[];
    onToggle: (value: T) => void;
};

/** A facet as toggle chips — several may be on at once. */
export function VehicleFilterChips<T extends string>({
    legend,
    options,
    selected,
    onToggle,
}: VehicleFilterChipsProps<T>) {
    if (!options.length) return null;

    return (
        <fieldset className="vehicle-filter__group">
            <legend className="vehicle-filter__legend label-xs">{legend}</legend>

            <div className="vehicle-filter__chips">
                {options.map((option) => (
                    <button
                        key={option.value}
                        type="button"
                        className="vehicle-filter-chip label-xs"
                        aria-pressed={selected.includes(option.value)}
                        onClick={() => onToggle(option.value)}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
        </fieldset>
    );
}
